import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

interface TabsWrapperProps {
    // TODO: Remove if this is never going to be supported.
    $canDrag?: boolean;
}

interface TabProps {
    $active?: boolean;
}

export const TabsWrapper = styled.div<TabsWrapperProps>`
    display: flex;
    justify-content: flex-start;
    width: 100%;

    ${({ $canDrag }) =>
        !$canDrag &&
        css`
            justify-content: center;
        `}
`;

export const Interior = styled(motion.div)<TabsWrapperProps>`
    display: flex;
    column-gap: 30px;

    ${({ $canDrag }) =>
        !$canDrag &&
        css`
            transform: none !important;
        `}
`;

export const Tab = styled.div<TabProps>`
    cursor: pointer;
    white-space: nowrap;
    opacity: ${({ $active }) => ($active ? 1 : 0.4)};
    transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;
`;
